import React from 'react';
import CheckboxField from 'components/pure/utils/form/CheckboxField';
import DatePicker from 'components/pure/utils/form/DatePicker';
import moment from 'moment';
import classNames from 'classnames';
import SharingFormActions from 'actions/sharing/SharingFormActions';

import 'react-widgets/styles.css';
import 'styles/Metadata.styl';
import './FileUploadSharingDialogFormExternalShares.sass';
import SharingActions from 'actions/sharing/SharingActions';

/**
 * <FileUploadSharingDialogFormExternalShares /> renders a vertical list of checkboxes and
 * related input text fields or datetime picker
 */
class FileUploadSharingDialogFormExternalShares extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      datetimePickerIsOpen: false,
      password: '',
    };
  }

  /**
   * User checks / changes the checked status of the "Expire access" checkbox. So we
   * call `SharingFormActions.updateExpireAccess` to update `FileUploadSharingDialogFormStore`
   * @param  {Event}  event          The click event object
   * @param  {Boolean} isChecked Whether the checkbox is checked or not
   */
  checkExpireAccess = (event, isChecked) => {
    SharingFormActions.updateExpireAccess(isChecked);
    if (isChecked) {
      this.props.onDataChanged('settings.expires');
    }
  };

  checkPasswordProtection = (event, isChecked) => {
    SharingFormActions.updatePasswordProtection(isChecked);
    if (isChecked) {
      this.props.onDataChanged('settings.password');
    }
  };

  /**
   * Triggered when the user toggles the datetime picker for expire access
   * @param  {Boolean} isOpen Whether the datetime picker is open or not
   */
  onToggleDateTimePicker(isOpen) {
    this.setState({
      datetimePickerIsOpen: isOpen,
    });
  }

  /**
   * Call `SharingFormActions.updatePassword` to update the request's password field
   */
  onPasswordBlur = () => {
    SharingFormActions.updatePassword(this.state.password);
    if (this.props.submitted) {
      SharingActions.sharingDataChanged(this.props.fileUpload);
    }
  };

  /**
   * Change `this.state.password` based on `event.target.value`
   * @param  {Event} event An event object when the user changes the password `input`
   */
  onPasswordChange = event => {
    this.setState({password: event.target.value});
    SharingFormActions.updatePassword(event.target.value);
    if (this.props.submitted) {
      SharingActions.sharingDataChanged(this.props.fileUpload);
    }
  };

  render() {
    const passwordFieldClass = ['password-field'];
    if (this.props.passwordProtected) {
      passwordFieldClass.push('password-field-show');
    } else {
      passwordFieldClass.push('password-field-hide');
    }
    const containerStyle = {
      zIndex: 2200,
    };

    return (
      <div className="external-sharing-settings">
        <div className="text-input-label">External sharing settings</div>
        <div
          className="element sharing-settings-element"
          ref={c => this.props.onShownRef('settings', c)}>
          <div>
            <CheckboxField
              className="checkbox"
              label="Password protection"
              checked={this.props.passwordProtected}
              onCheck={this.checkPasswordProtection}
            />
            <input
              placeholder="Password"
              value={this.state.password}
              className={classNames('external-shares-widget', passwordFieldClass, {
                'error-field': this.props.shareDataError.get('password'),
              })}
              onBlur={this.onPasswordBlur}
              onChange={this.onPasswordChange}
            />
            {this.props.shareDataError.get('password') && (
              <div className="password-error">This field is required</div>
            )}
            <CheckboxField
              className="checkbox"
              label="Expire access"
              checked={this.props.expireAccess}
              onCheck={this.checkExpireAccess}
            />
            {this.props.expireAccess && (
              <div className="external-shares-widget date-picker-container">
                <DatePicker
                  value={this.props.willExpireAccess}
                  dialogContainerStyle={containerStyle}
                  hintText="mm/dd/yyyy"
                  minDate={moment()}
                  onChange={onExpireAccessChange}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

/**
 * User updates the datetime a sharing will expire
 * @param  {string} value String representation of `date`
 */
function onExpireAccessChange(value) {
  SharingFormActions.updateWillExpireAccess(value);
}

export default FileUploadSharingDialogFormExternalShares;
